import { render, staticRenderFns } from "./SingleProductSkeleton.vue?vue&type=template&id=91a3c4cc&scoped=true&"
import script from "./SingleProductSkeleton.vue?vue&type=script&lang=js&"
export * from "./SingleProductSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a3c4cc",
  null
  
)

export default component.exports